import { InputLabel } from "@mui/material";
import styled from "../transient-styled";

export const StyledInputLabel = styled(InputLabel)`
    margin-top: 17px;
    margin-bottom: 6px;
`;
